export default class ChatBotTipoNoApiParametroTiposEnum {
    static SemParametros = 1
    static Body = 2
    static Lista = 3
}
